module.exports = __webpack_public_path__ + "img/tradeBn.176829bd.png";